import React from 'react';
import {PolyElement, createPolymorphicComponent} from '../../Utilities/createPolymorphicComponent';
import {ModifierClasses} from '../shared/types';
import scss from './Text.module.scss';

type Modifier<S extends string> = ModifierClasses<S, typeof scss>;

const getTextClasses = ({font, color}: RsnText.Props) => {
    return [scss.base, font && scss[`font--${font}`], color && scss[`color--${color}`]].filter(Boolean).join(' ');
};

const RsnText = Object.assign(
    createPolymorphicComponent('span')<RsnText.Props>(({font, color, className = '', ...props}) => (
        <PolyElement {...props} className={`${getTextClasses({font, color})} ${className}`} />
    )),
    {
        getClasses: getTextClasses,
    }
);

namespace RsnText {
    export type Props = {
        font?: Font;
        color?: Color;
        className?: string;
    };
    export type Color = Modifier<'color'>;
    export type Font = Modifier<'font'>;
}

export default RsnText;
